import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ShiftRoster, ShiftRosterCreate, ShiftRosterFilter } from '../data/shiftRoster';

export function createShiftRosterService(client: AxiosInstance) {
  return createCrudService<ShiftRoster, ShiftRosterCreate, ShiftRosterFilter>(
    client,
    '/hrm/ShiftRoster',
    'id',
  );
}

export type ShiftRosterService = CrudService<ShiftRoster, ShiftRosterCreate, ShiftRosterFilter>;
